export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
  DEEP_DIVE: '/deep-dive/:sectionId',
} as const

export type Route = (typeof ROUTES)[keyof typeof ROUTES]

export const deepDivePath = (sectionId: string): string =>
  ROUTES.DEEP_DIVE.replace(':sectionId', encodeURIComponent(sectionId))
